import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResourcePage from "../components/ResourcePage";
import SupplierCompliance from "../components/suppliers/SupplierCompliance";
import SupplierReport from "../components/suppliers/SupplierReport";
import SupplierPreferences from "../components/suppliers/SupplierPreferences";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";

export default function Suppliers() {
  const loc = useLocation();
  const nav = useNavigate();
  const tab = loc.pathname.endsWith("/report") ? "report" : loc.pathname.endsWith("/scadenze") ? "scadenze" : loc.pathname.endsWith("/preferiti") ? "preferiti" : "anagrafica";
  const go = (v) => nav(v === "anagrafica" ? "/fornitori" : `/fornitori/${v}`);
  return (
    <div className="space-y-4" data-testid="page-suppliers">
      <Tabs value={tab} onValueChange={go}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="anagrafica" data-testid="stab-anagrafica">Anagrafica imprese e fornitori</TabsTrigger>
          <TabsTrigger value="preferiti" data-testid="stab-preferiti">Preferiti e ordini</TabsTrigger>
          <TabsTrigger value="scadenze" data-testid="stab-scadenze">Scadenze e DURC</TabsTrigger>
          <TabsTrigger value="report" data-testid="stab-report">Report consumi</TabsTrigger>
        </TabsList>
        <TabsContent value="anagrafica"><ResourcePage resource="suppliers" /></TabsContent>
        <TabsContent value="preferiti"><SupplierPreferences /></TabsContent>
        <TabsContent value="scadenze"><SupplierCompliance /></TabsContent>
        <TabsContent value="report"><SupplierReport /></TabsContent>
      </Tabs>
    </div>
  );
}
